"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadCostApi = exports.LeadCostApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
// @ts-ignore
const models_2 = require("../models");
/**
 * LeadCostApi - axios parameter creator
 * @export
 */
const LeadCostApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} leadCostId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLeadCost: async (leadCostId, options = {}) => {
            // verify required parameter 'leadCostId' is not null or undefined
            (0, common_1.assertParamExists)('deleteLeadCost', 'leadCostId', leadCostId);
            const localVarPath = `/api/lead-cost/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (leadCostId !== undefined) {
                localVarQueryParameter['leadCostId'] = leadCostId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ILeadCostSearchEntity} iLeadCostSearchEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLeadCosts: async (iLeadCostSearchEntity, options = {}) => {
            // verify required parameter 'iLeadCostSearchEntity' is not null or undefined
            (0, common_1.assertParamExists)('listLeadCosts', 'iLeadCostSearchEntity', iLeadCostSearchEntity);
            const localVarPath = `/api/lead-cost/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iLeadCostSearchEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ILeadTypeCostEntity} iLeadTypeCostEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertLeadCost: async (iLeadTypeCostEntity, options = {}) => {
            // verify required parameter 'iLeadTypeCostEntity' is not null or undefined
            (0, common_1.assertParamExists)('upsertLeadCost', 'iLeadTypeCostEntity', iLeadTypeCostEntity);
            const localVarPath = `/api/lead-cost/upsert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iLeadTypeCostEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.LeadCostApiAxiosParamCreator = LeadCostApiAxiosParamCreator;
/**
 * LeadCostApi -
 */
var LeadCostApi;
(function (LeadCostApi) {
    /**
     *
     * @param {number} leadCostId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof LeadCostApi
     * url /api/lead-cost/delete
     */
    async function deleteLeadCost(leadCostId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.LeadCostApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLeadCost(leadCostId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    LeadCostApi.deleteLeadCost = deleteLeadCost;
    /**
     *
     * @param {ILeadCostSearchEntity} iLeadCostSearchEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof LeadCostApi
     * url /api/lead-cost/list
     */
    async function listLeadCosts(iLeadCostSearchEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.LeadCostApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.listLeadCosts(iLeadCostSearchEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_2.parseInlineResponse2007)(res.data);
            return res;
        });
    }
    LeadCostApi.listLeadCosts = listLeadCosts;
    /**
     *
     * @param {ILeadTypeCostEntity} iLeadTypeCostEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof LeadCostApi
     * url /api/lead-cost/upsert
     */
    async function upsertLeadCost(iLeadTypeCostEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.LeadCostApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.upsertLeadCost(iLeadTypeCostEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseILeadTypeCostEntity)(res.data);
            return res;
        });
    }
    LeadCostApi.upsertLeadCost = upsertLeadCost;
})(LeadCostApi || (exports.LeadCostApi = LeadCostApi = {}));
